import { Component, Input, Output, EventEmitter, OnChanges, SimpleChanges, AfterViewInit, ViewChildren, QueryList, ElementRef, HostListener } from '@angular/core';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-navbar',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './navbar.component.html',
  styleUrl: './navbar.component.css'
})
export class NavbarComponent implements OnChanges, AfterViewInit {
  @Input() items: Array<{ id: string; label: string; selectedIcon: string; unselectedIcon: string }>= [];
  @Input() selectedId: string | null | undefined = null;
  @Output() selectedIdChange = new EventEmitter<string>();

  currentId: string | null = null;
  underlineLeftPx = 0;
  underlineWidthPx = 0;
  @ViewChildren('navItem') navItemEls!: QueryList<ElementRef<HTMLElement>>;

  ngOnChanges(changes: SimpleChanges): void {
    // Respect explicit binding, including empty string to indicate "no selection"
    if (this.selectedId !== undefined && this.selectedId !== this.currentId) {
      this.currentId = this.selectedId ?? null;
    }
    // Only auto-select first if no binding was provided (selectedId is undefined)
    if (this.selectedId === undefined && (this.currentId == null) && this.items.length) {
      this.currentId = this.items[0].id;
    }
  }

  isSelected(id: string): boolean {
    return this.currentId === id;
  }

  select(id: string): void {
    if (this.currentId === id) return;
    this.currentId = id;
    this.selectedIdChange.emit(id);
  }

  ngAfterViewInit(): void {
    setTimeout(() => this.computeUnderline(), 0);
  }

  @HostListener('window:resize')
  onResize(): void {
    this.computeUnderline();
  }

  private computeUnderline(): void {
    // Grid guarantees 3 equal columns; underline spans the middle third
    const nav = this.navItemEls?.first?.nativeElement?.parentElement as HTMLElement | undefined;
    if (!nav) return;
    const rect = nav.getBoundingClientRect();
    this.underlineLeftPx = rect.width / 3; // start of column 2
    this.underlineWidthPx = rect.width / 3; // width of column 2
  }
}


